export const topics = [
  {
    slug: 'chengdu-yinyuejie-linye-jiaoting',
    title: '成都音乐节临开演突然叫停，主办方连夜发布说明',
    summary:
      '原定今晚开场的户外音乐节在检票前一小时临时取消，现场已聚集数千名观众。主办方深夜连发两条说明，承诺三日内公布退票与改期方案。',
    categorySlug: 'ent',
    tag: '突发',
    heat: 9876000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20empty%20outdoor%20concert%20stage%20with%20dramatic%20spotlights%20and%20scattered%20light%20beams%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20graphic%20shapes%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20wide%20cinematic%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-01&orientation=landscape',
    coverAlt: '音乐节舞台与灯光的设计插图',
    publishedAt: '2026-09-10 22:14',
    timeAgo: '12分钟前',
    readCount: 184320,
    commentCount: 4210,
    tags: ['音乐节', '突发叫停', '退票'],
    timeline: [
      { time: '21:05', text: '现场观众陆续抵达，检票口开始排队，舞台灯光进入最后调试。' },
      { time: '21:40', text: '主办方工作人员用广播通知演出临时取消，现场一度出现骚动。' },
      { time: '22:14', text: '官方账号发布第一条说明，称因场地安全评估未通过，演出无法如期举行。' },
      { time: '23:30', text: '第二条说明公布退票通道，承诺三日内给出改期或全额退款方案。' },
    ],
    paragraphs: [
      '今晚的音乐节原本是这座城市入秋后规模最大的一场户外演出，票务平台显示两万余张门票在开票当天就已售罄。但就在检票前一小时，等候在入口处的人群突然收到演出取消的广播通知。',
      '现场观众拍摄的画面里，舞台灯光仍在运行，但乐队设备已被工作人员陆续撤下。多名观众表示，自己是从外地专程赶来，返程车票和住宿都已无法更改。',
      '主办方随后发布说明，将取消原因归结为场地临时安全评估未通过，并表示已协调票务平台开启全额退票通道。截至发稿，场内观众已陆续离场，具体改期时间尚未公布。',
    ],
    related: ['yanchanghui-menpiao-miaokong', 'chengshi-baoyu-neilao'],
  },
  {
    slug: 'waimai-pingtai-peisongfei-xiatiao',
    title: '多家外卖平台同日下调配送费，商家与骑手各说各话',
    summary:
      '三个主流外卖平台在同一天宣布降低配送费标准，部分城市起步价回到三年前水平。商家担心流量重新分配，骑手则更在意单量与补贴是否同步调整。',
    categorySlug: 'tech',
    tag: '热议',
    heat: 8654000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20food%20delivery%20scooter%20parked%20beside%20takeout%20boxes%20and%20a%20paper%20route%20map%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20accents%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-02&orientation=landscape',
    coverAlt: '外卖配送场景的设计插图',
    publishedAt: '2026-09-10 18:02',
    timeAgo: '4小时前',
    readCount: 132870,
    commentCount: 3160,
    tags: ['外卖', '配送费', '平台调整'],
    timeline: [
      { time: '上午 09:20', text: '第一家平台在商家端推送配送费调整通知，覆盖十二个重点城市。' },
      { time: '中午 12:45', text: '另外两家平台先后跟进，起步价与距离费同步下调。' },
      { time: '下午 18:02', text: '骑手社群开始讨论新计费规则，关注点集中在单量与高峰补贴。' },
    ],
    paragraphs: [
      '调整之后，多数城市的配送起步价降至四元以内，三公里以上的距离费也同步收窄。平台给出的理由是订单密度提升，单均成本随之下降。',
      '对商家来说，配送费下调意味着整体履约成本更低，但也有店主担心平台会用流量重新分配来换取更低的抽佣，实际到手利润未必增加。',
      '骑手社群讨论的焦点则完全不同：如果单量不能同步增长，单均收入将被直接稀释。多名骑手表示正在观望本周的实际流水再做决定。',
    ],
    related: ['guochan-shouji-yingxiang-shengji', 'dachang-quxiao-daxiaozhou'],
  },
  {
    slug: 'gaokao-zhiyuan-rengongzhineng-zhuanye',
    title: '多所高校新增人工智能类专业，志愿填报多了一批新选项',
    summary:
      '教育部公布的新增备案专业里，人工智能与智能装备方向占据了相当比例。招生办提醒考生，新专业师资与培养方案差异较大，别只看名字热不热。',
    categorySlug: 'campus',
    tag: '关注',
    heat: 7420000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20stacked%20university%20textbooks%2C%20a%20graduation%20cap%20and%20a%20pencil%20on%20a%20study%20desk%2C%20warm%20cream%20background%20with%20orange%20and%20teal%20graphic%20accents%2C%20soft%20paper%20grain%2C%20flat%20geometric%20poster%20style%2C%20clean%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-03&orientation=landscape',
    coverAlt: '高校教材与毕业帽的设计插图',
    publishedAt: '2026-09-10 15:40',
    timeAgo: '6小时前',
    readCount: 98650,
    commentCount: 1840,
    tags: ['高考', '志愿填报', '人工智能专业'],
    timeline: [
      { time: '09:00', text: '新增备案本科专业名单对外公布，智能类方向数量位居前列。' },
      { time: '13:20', text: '多所高校招生办发布专业解读，说明课程结构与实训安排。' },
      { time: '15:40', text: '志愿填报咨询量明显上涨，家长群转发相关就业数据。' },
    ],
    paragraphs: [
      '从名单来看，新增专业集中在人工智能、智能装备、数据治理等方向，不少是传统工科专业改造后重新备案。',
      '招生办工作人员在解读中反复提到一个提醒：同一个专业名称，不同学校的课程结构可能完全不同，师资储备与实验室条件才是判断标准。',
      '多位高三教师建议，填报时先看培养方案再看名字，同时留意该专业是否保留了转专业与辅修的通道。',
    ],
    related: ['tushuguan-tongxiao-kaoyan', 'fangdai-lilv-zaijiang'],
  },
  {
    slug: 'fangdai-lilv-zaijiang',
    title: '多地房贷利率再降，售楼处连夜接到咨询电话',
    summary:
      '新一轮利率调整落地后，部分城市首套房贷利率降至历史低位。购房者最关心的不是利率本身，而是存量房贷能否同步享受新标准。',
    categorySlug: 'finance',
    tag: '持续',
    heat: 7130000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20rising%20line%20chart%20above%20simplified%20city%20buildings%20and%20house%20keys%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20shapes%2C%20soft%20grain%20texture%2C%20flat%20geometric%20financial%20poster%20style%2C%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-04&orientation=landscape',
    coverAlt: '房贷利率与城市建筑的设计插图',
    publishedAt: '2026-09-10 11:25',
    timeAgo: '10小时前',
    readCount: 87400,
    commentCount: 2260,
    tags: ['房贷利率', '购房', '存量房贷'],
    timeline: [
      { time: '08:30', text: '多家银行更新首套房贷利率报价，重点城市同步执行。' },
      { time: '11:25', text: '售楼处反馈咨询电话明显增多，到访量在两小时内翻倍。' },
      { time: '16:10', text: '业内解读普遍关注存量房贷调整的落地节奏。' },
    ],
    paragraphs: [
      '这一轮调整主要影响新发放贷款，多个城市首套房贷利率已经降到近年低位，月供压力相比去年同期明显减轻。',
      '不过购房者的关注点很快从利率本身转向另一个问题：已经放款的存量房贷能否同步调整。目前各银行口径并不一致，多数仍以合同约定为准。',
      '有中介机构测算，如果存量房贷能随之下调，一个百万级贷款家庭每年可省下数千元利息，这也是讨论热度持续上涨的原因。',
    ],
    related: ['jingji-shuju-xinchulu', 'waimai-pingtai-peisongfei-xiatiao'],
  },
  {
    slug: 'dachang-quxiao-daxiaozhou',
    title: '某互联网公司取消大小周后，员工晒出真实下班时间',
    summary:
      '取消大小周的通知发出已满三个月，员工在社交平台晒出的打卡记录显示，下班时间确实提前了，但周末临时线上会议变多了。',
    categorySlug: 'career',
    tag: '热议',
    heat: 6890000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20tidy%20office%20desk%20with%20laptop%2C%20coffee%20cup%20and%20clock%20showing%20evening%20time%2C%20warm%20cream%20background%20with%20orange%20and%20teal%20geometric%20accents%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20calm%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-05&orientation=landscape',
    coverAlt: '办公桌面与时钟的设计插图',
    publishedAt: '2026-09-10 09:15',
    timeAgo: '13小时前',
    readCount: 112600,
    commentCount: 3980,
    tags: ['职场', '大小周', '加班'],
    timeline: [
      { time: '06-12', text: '公司内部邮件宣布取消大小周，恢复双休。' },
      { time: '08-20', text: '有员工在社交平台晒出连续两周打卡记录，平均下班时间提前。' },
      { time: '09-10', text: '讨论延伸至线上会议与隐性加班，话题冲上热搜。' },
    ],
    paragraphs: [
      '通知发布时，很多员工把取消大小周当成一个明确的信号：工作节奏要往回收一收了。三个月过去，打卡记录确实支持了这个判断。',
      '但另一组数据同样显眼：周末的线上会议邀请数量增加了。有员工形容，人是不用来公司了，但消息照旧在周末弹出来。',
      '人力研究者的看法是，制度层面的减负容易落地，真正难改的是团队对响应速度的默认期待。这也是讨论迟迟无法平息的原因。',
    ],
    related: ['waimai-pingtai-peisongfei-xiatiao', 'jingji-shuju-xinchulu'],
  },
  {
    slug: 'quanyunhui-yongyong-juejin-baoleng',
    title: '全运会游泳决赛爆冷，十九岁新秀刷新赛会纪录夺金',
    summary:
      '赛前并不被看好的年轻选手在最后五十米完成反超，游出新的赛会纪录。赛后采访里，他把成绩归功于后半程的节奏调整。',
    categorySlug: 'sports',
    tag: '焦点',
    heat: 6480000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20competition%20swimming%20pool%20with%20lane%20ropes%20and%20splashing%20water%20shapes%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20graphic%20accents%2C%20soft%20grain%20texture%2C%20flat%20geometric%20sports%20poster%20style%2C%20dynamic%20wide%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-06&orientation=landscape',
    coverAlt: '游泳比赛泳道与浪花的设计插图',
    publishedAt: '2026-09-09 22:48',
    timeAgo: '昨天',
    readCount: 76500,
    commentCount: 1420,
    tags: ['全运会', '游泳', '赛会纪录'],
    timeline: [
      { time: '21:10', text: '决赛名单公布，年轻选手以预赛第四进入决赛。' },
      { time: '22:30', text: '最后五十米完成反超，触壁成绩刷新赛会纪录。' },
      { time: '22:48', text: '赛后采访视频流出，节奏调整成为讨论重点。' },
    ],
    paragraphs: [
      '决赛前半程，年轻选手一直处在第三的位置，转身之后才开始加速。最后五十米，他在第三个泳道完成了关键反超。',
      '计时板亮出的成绩刷新了该项目的赛会纪录。赛后他提到，教练组在预赛后专门调整了后半程的划频安排，这次尝试收到了效果。',
      '这场比赛也让更多人开始关注梯队建设的话题，多名年轻选手在本次赛事中游出了个人最好成绩。',
    ],
    related: ['dachang-quxiao-daxiaozhou', 'gaokao-zhiyuan-rengongzhineng-zhuanye'],
  },
  {
    slug: 'guochan-shouji-yingxiang-shengji',
    title: '国产手机厂商集体上新，影像大战再升级',
    summary:
      '一周之内四家厂商发布新机，主摄传感器与长焦方案几乎同步升级。消费者更关心的价格区间和真实成像，发布会讲的算法差异看不太懂。',
    categorySlug: 'tech',
    tag: '新品',
    heat: 6120000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20three%20modern%20smartphones%20with%20large%20camera%20lenses%20arranged%20in%20a%20fan%20layout%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20geometric%20accents%2C%20soft%20grain%20texture%2C%20flat%20product%20poster%20style%2C%20no%20text&width=800&height=500&seq=baoliao-topic-07&orientation=landscape',
    coverAlt: '智能手机与摄像头模组的设计插图',
    publishedAt: '2026-09-09 20:05',
    timeAgo: '昨天',
    readCount: 69300,
    commentCount: 2050,
    tags: ['国产手机', '影像', '新品发布'],
    timeline: [
      { time: '周一', text: '首家厂商发布影像旗舰，重点讲长焦与夜景算法。' },
      { time: '周三', text: '另外三家相继跟进，同价位段竞争明显加剧。' },
      { time: '周五', text: '线下体验店出现排队试拍，样张对比帖传播迅速。' },
    ],
    paragraphs: [
      '本轮上新的共同点是影像，四家厂商不约而同把长焦与夜景作为主要卖点，传感器尺寸也普遍上探。',
      '不过发布会上的算法描述越来越抽象，普通用户很难从参数里读出实际差距，于是线下试拍和第三方样张对比成了更受信任的参考。',
      '价格上，几家都把主力机型压在同一个区间，有渠道商表示这会让中端市场的换机周期变得更短。',
    ],
    related: ['waimai-pingtai-peisongfei-xiatiao', 'jingji-shuju-xinchulu'],
  },
  {
    slug: 'shequ-shitang-laoren-canjia',
    title: '社区食堂开到家门口，老人一顿饭只要八块钱',
    summary:
      '多个街道把闲置空间改造成社区食堂，针对六十岁以上居民推出惠民价。开业第一周就出现排队，运营方仍在测算如何长期维持。',
    categorySlug: 'society',
    tag: '身边事',
    heat: 5680000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20warm%20home%20style%20meal%20trays%20on%20a%20canteen%20table%20with%20steam%20swirls%2C%20warm%20cream%20background%20with%20orange%20and%20teal%20graphic%20accents%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20cozy%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-08&orientation=landscape',
    coverAlt: '社区食堂餐盘与热气的设计插图',
    publishedAt: '2026-09-09 16:30',
    timeAgo: '昨天',
    readCount: 54800,
    commentCount: 980,
    tags: ['社区食堂', '养老', '惠民'],
    timeline: [
      { time: '08-28', text: '首批社区食堂完成改造，进入试运营阶段。' },
      { time: '09-03', text: '惠民价方案公布，六十岁以上居民每餐八元。' },
      { time: '09-09', text: '午间出现排队，社区增派志愿者维持秩序。' },
    ],
    paragraphs: [
      '这些社区食堂大多由闲置的门面房或物业用房改造，厨房与就餐区分开设置，中午十一点半开始供餐。',
      '菜式以家常菜为主，两荤一素的搭配固定，六十岁以上居民凭卡每餐八元，周边上班族也可以按原价就餐。',
      '运营方坦言，目前的定价需要依靠街道补贴和客流规模支撑，接下来会通过承接团餐和晚间档来平衡成本。',
    ],
    related: ['chengshi-baoyu-neilao', 'tushuguan-tongxiao-kaoyan'],
  },
  {
    slug: 'tushuguan-tongxiao-kaoyan',
    title: '高校图书馆通宵开放，考研人凌晨还在排队占座',
    summary:
      '进入备考冲刺期，多所高校把图书馆的闭馆时间延后到凌晨两点，并开放部分自习教室通宵运行。座位预约系统上线当天就被约满。',
    categorySlug: 'campus',
    tag: '关注',
    heat: 5210000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20quiet%20library%20at%20night%20with%20tall%20bookshelves%2C%20reading%20lamps%20and%20glowing%20windows%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20accents%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20no%20text&width=800&height=500&seq=baoliao-topic-09&orientation=landscape',
    coverAlt: '夜晚图书馆与阅读灯的设计插图',
    publishedAt: '2026-09-09 14:12',
    timeAgo: '昨天',
    readCount: 49600,
    commentCount: 1120,
    tags: ['考研', '图书馆', '通宵自习'],
    timeline: [
      { time: '09-06', text: '图书馆发布延长开放时间通知，闭馆时间调整至凌晨两点。' },
      { time: '09-08', text: '座位预约系统开放，十分钟内当日名额全部约满。' },
      { time: '09-09', text: '学校增开两间通宵自习教室并延长热水供应。' },
    ],
    paragraphs: [
      '备考冲刺阶段的自习需求集中在深夜，延长开放时间几乎成了各高校的统一动作，有的学校还专门安排了通宵教室。',
      '座位预约系统虽然缓解了占座问题，但名额依然紧张。有学生凌晨五点就开始在门口排队，只为了拿到靠窗的位置。',
      '图书馆方面表示，会在保证安全的前提下逐步增加座位，同时提醒同学注意作息，别把身体熬垮。',
    ],
    related: ['gaokao-zhiyuan-rengongzhineng-zhuanye', 'shequ-shitang-laoren-canjia'],
  },
  {
    slug: 'chengshi-baoyu-neilao',
    title: '暴雨夜城市多处内涝，市政连夜排水抢险',
    summary:
      '强降雨集中在傍晚到凌晨，城区数个下穿隧道出现积水，市政部门调集泵车与抢险队通宵作业，早高峰前主要路段恢复通行。',
    categorySlug: 'city',
    tag: '突发',
    heat: 4980000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20rainy%20city%20street%20at%20night%20with%20puddles%2C%20umbrellas%20and%20street%20lamps%20reflecting%20on%20wet%20asphalt%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20graphic%20shapes%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20no%20text&width=800&height=500&seq=baoliao-topic-10&orientation=landscape',
    coverAlt: '暴雨夜晚城市街道的设计插图',
    publishedAt: '2026-09-09 07:40',
    timeAgo: '昨天',
    readCount: 62300,
    commentCount: 1340,
    tags: ['暴雨', '城市内涝', '抢险'],
    timeline: [
      { time: '18:30', text: '气象部门发布暴雨橙色预警，降雨量在两小时内快速攀升。' },
      { time: '21:15', text: '城区多个下穿隧道出现积水，交警实施临时交通管制。' },
      { time: '次日 05:20', text: '泵车持续作业，主要路段积水退去，早高峰前恢复通行。' },
    ],
    paragraphs: [
      '这场降雨来得又快又急，两个小时内的降水量就超过了历史同期单日水平，排水系统短时间难以消化。',
      '市政部门在夜间调集了多台移动泵车，对积水严重的下穿隧道进行强排，同时安排抢险队巡查易涝点。',
      '到清晨五点多，主干道积水基本退去，公交线路陆续恢复。市政方面表示会复盘本次排水表现，加快低洼路段的管网改造。',
    ],
    related: ['shequ-shitang-laoren-canjia', 'chengdu-yinyuejie-linye-jiaoting'],
  },
  {
    slug: 'yanchanghui-menpiao-miaokong',
    title: '演唱会门票开票秒空，黄牛加价三倍被集中举报',
    summary:
      '一场热门演唱会开票即售罄，随后二手平台出现大量加价票。票务方称已启动异常订单排查，并对部分账号进行限购处罚。',
    categorySlug: 'ent',
    tag: '热议',
    heat: 4720000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20paper%20concert%20tickets%20and%20a%20queue%20barrier%20ribbon%20on%20a%20bright%20surface%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20accents%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20minimal%20composition%2C%20no%20text&width=800&height=500&seq=baoliao-topic-11&orientation=landscape',
    coverAlt: '演唱会门票与排队护栏的设计插图',
    publishedAt: '2026-09-08 21:30',
    timeAgo: '2天前',
    readCount: 71500,
    commentCount: 2680,
    tags: ['演唱会', '黄牛', '实名制'],
    timeline: [
      { time: '20:00', text: '门票正式开售，三十秒内全价位售罄。' },
      { time: '20:40', text: '二手平台出现加价票，部分价格翻了三倍。' },
      { time: '21:30', text: '票务方公告启动异常订单排查，并回应限购机制。' },
    ],
    paragraphs: [
      '这场演唱会的票价区间并不算高，但开票后三十秒内就全部售罄，让不少守在屏幕前的粉丝一头雾水。',
      '很快，二手平台上出现了大量加价票，价格普遍是原价的两到三倍，部分位置甚至标出更高的溢价。',
      '票务方回应称，已对可疑订单进行排查，并对同一身份信息下的异常购买行为作了限购处理，后续将强化实名核验环节。',
    ],
    related: ['chengdu-yinyuejie-linye-jiaoting', 'guochan-shouji-yingxiang-shengji'],
  },
  {
    slug: 'jingji-shuju-xinchulu',
    title: '最新经济数据出炉，这几个行业增长最猛',
    summary:
      '统计部门公布的最新数据显示，服务消费与高端制造增速领先，新能源装备的出口表现尤其突出。业内对下半年的判断出现分歧。',
    categorySlug: 'finance',
    tag: '数据',
    heat: 4360000,
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20bar%20charts%2C%20pie%20segments%20and%20upward%20arrows%20arranged%20as%20a%20dashboard%20report%2C%20warm%20cream%20background%20with%20bold%20orange%20and%20deep%20teal%20geometric%20accents%2C%20soft%20grain%20texture%2C%20flat%20geometric%20poster%20style%2C%20no%20text&width=800&height=500&seq=baoliao-topic-12&orientation=landscape',
    coverAlt: '经济数据图表与上升箭头的设计插图',
    publishedAt: '2026-09-08 10:00',
    timeAgo: '2天前',
    readCount: 58900,
    commentCount: 860,
    tags: ['经济数据', '行业增长', '消费'],
    timeline: [
      { time: '09:30', text: '月度数据对外发布，服务业与制造业指数同步公布。' },
      { time: '10:00', text: '机构解读陆续出炉，聚焦高端制造与出口结构变化。' },
      { time: '15:00', text: '二级市场相关板块出现明显波动。' },
    ],
    paragraphs: [
      '数据里最显眼的是服务消费的回暖，餐饮、演出和出行相关的指标都保持在较高增速。',
      '制造业方面，高端装备与新能源相关的订单增长明显，出口结构也在往技术含量更高的方向移动。',
      '不过对下半年的判断，机构之间并不一致。乐观的一方看重订单储备，谨慎的一方更担心外部需求的不确定性。',
    ],
    related: ['fangdai-lilv-zaijiang', 'guochan-shouji-yingxiang-shengji'],
  },
];